<template>
  <div class="section-title">
    <div class="section-title-content">
      <h2 v-html="title"></h2>
      <p>{{ subtitle }}</p>
    </div>
    <RouterLink :to="buttonLink" v-if="hideButton">
      {{ buttonLabel }}
      <span v-if="hasArrow">
        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 8.81836L6.938 7.75636L9.125 5.56836H0V4.06836H9.125L6.938 1.88036L8 0.818359L12 4.81836L8 8.81836Z" fill="#3D3E3F"/>
        </svg>
      </span>
    </RouterLink>
  </div>
</template> 

<script>
import Vue from 'vue'
import '@/assets/scss/custom/franquias/components/_section-title.scss'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: false
    },
    buttonLabel: {
      type: String,
      required: false
    },
    buttonLink: {
      type: String,
      required: false
    },
    hasArrow: {
      type: Boolean,
      default: false,
    }

  }
}
</script>
